/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';

/**
 * Identifier for the root folder.
 */
export const ROOT_FOLDER = 'rootFolder';

/**
 * List of dashboard category names.
 */
export const USAGE_ANALYTICS = 'Usage Analytics';
export const GEOFENCE_REPORTS = 'Geofence Reports';
export const EXCEPTION_MANAGEMENT = 'Exception Management';
export const CARGO_MONITORING = 'Cargo Monitoring';
export const MAINTENANCE_REPORTS = 'Maintenanace Reports';
export const FUEL_AND_ENERGY = 'Fuel & Energy';
export const TRAILER_REPORTS = 'Trailer Reports';
export const ENGINE_DIAGNOSTIC_REPORTS = 'Engine Diagnostic';
export const DASHBOARD_CHARTS = 'Dashboard Charts';
export const DMCTC_REPORTS = 'DMCTC Reports';
export const ASSET_ACTIVITY = 'Asset Activity';
export const DRIVER_ACTIVITY_AND_SAFETY = 'Driver Activity & Safety';
export const LOTSMART_REPORTS = 'Lotsmart Reports';
export const THIRD_PARTY_INTEGRATION = 'Third Party Integration';
export const TRIP_STOP_AND_LOCATION_REPORTS = 'Trip, Stop & Location Reports';
export const UTILIZATION = 'Utilization';
export const VEHICLE_INSPECTION = 'Vehicle Inspection';
export const K12_DASHBOARDS = 'K12 Dashboards';
export const SAFETY_DASHBOARD = 'Safety Dashboard';
export const FLEET_DASHBOARD = 'Fleet Dashboards';

/**
 * List of folder names considered as "Basic".
 */
export const BASIC_FOLDERS = [
  ASSET_ACTIVITY,
  CARGO_MONITORING,
  DASHBOARD_CHARTS,
  DRIVER_ACTIVITY_AND_SAFETY,
  ENGINE_DIAGNOSTIC_REPORTS,
  EXCEPTION_MANAGEMENT,
  FLEET_DASHBOARD,
  FUEL_AND_ENERGY
];

/**
 * Tabs used in the side navigation.
 */
export enum SideNavTabs {
  Basic = 0,
  Advanced = 1,
  MyReports = 2
}

/**
 * Tabs used in the dashboard header.
 */
export enum Headertabs {
  All = 0,
  Recent = 1,
  ScheduledReports = 2,
  MigrationResults = 3
}

/**
 * Parameters used to filter and retrieve dashboards.
 */
export interface GetCurrentDashboardsParams {
  categories: any[];
  selectedCategory: string | null;
  searchValue: string;
  categoryFilter?: string[];
  sortByDate: boolean;
};

// side navigation panel width
export const PANEL_WIDTH = 300;

// min width for drawer
export const MIN_DRAWER_WIDTH = 180;

// max width for drawer
export const MAX_DRAWER_WIDTH = 444;

// report card's width
export const REPORT_CARD_WIDTH = '320px';

export type ScheduledReportsEntryMode = 'direct' | 'dashboardRow';
